const UNKNOWN_USER_MESSAGE = 'Unknown User';
const UNKNOWN_EMAIL_ADDRESS_MESSAGE = 'Unknown Email Address';
function getEmailValue(userProfile, showUnknown = false) {
    // For internal users, the property is "upn", for external users, it's "email" and if we impersonate it is mail
    return (userProfile.upn ||
        userProfile.email ||
        userProfile.mail ||
        (showUnknown ? UNKNOWN_EMAIL_ADDRESS_MESSAGE : undefined));
}
export function isExternalUser(userProfile) {
    return userProfile.userType === 'Guest';
}
export function isInternalUser(userProfile) {
    return !isExternalUser(userProfile);
}
export function getUserType(userProfile) {
    return isExternalUser(userProfile) ? 'External' : 'Internal';
}
export function getLDAPUsername(userProfile) {
    return userProfile.mailNickname ? userProfile.mailNickname.toLocaleLowerCase() : undefined;
}
export function getAdalId(user) {
    return user && user.profile ? user.profile.oid : undefined;
}
/**
 * Gets the display name of the user
 *
 * @export
 * @param {(adal.User | UserProfile)} user
 * @param {{
 *     addEmail?: boolean;
 *     addUserTypeIfExternal?: boolean;
 *     undefinedIfNotFound?: boolean;
 *   }} [options={}] Extra options to change what it returns
 * @returns {string}
 */
export function getDisplayName(user, options = {}) {
    if (!user) {
        return undefined;
    }
    const userProfile = user.profile ? user.profile : user;
    if (!userProfile) {
        return options.undefinedIfNotFound ? undefined : UNKNOWN_USER_MESSAGE;
    }
    let alreadyUsingEmail = false;
    // if user is being impersonated, the value is "name"
    let displayName = userProfile.displayName || userProfile.name;
    if (!displayName) {
        displayName = getLDAPUsername(userProfile);
    }
    if (!displayName) {
        displayName = user.userName || getEmailValue(userProfile, false);
        alreadyUsingEmail = !!displayName;
    }
    if (!displayName) {
        return UNKNOWN_USER_MESSAGE;
    }
    if (!alreadyUsingEmail && options.addEmail) {
        displayName += ` (${getEmailValue(userProfile, true)})`;
    }
    if (options.addUserTypeIfExternal && isExternalUser(userProfile)) {
        const userTypeSuffix = ` (${getUserType(userProfile)})`;
        if (!displayName.includes(userTypeSuffix)) {
            displayName += userTypeSuffix;
        }
    }
    return displayName;
}
/**
 * Returns the given name of the user
 * Note: Not all user profiles have this set.
 *
 * @export
 * @param {adal.User} user
 * @returns {string}
 * @deprecated
 */
export function getAdalFirstName(user) {
    // If impersonating the profile has a UserProfile, given_name = givenName
    return user && user.profile ? user.profile.given_name || user.profile.givenName : undefined;
}
/**
 * Returns the surname (last name) of the user
 * Note: Not all user profiles have this set.
 *
 * @export
 * @param {adal.User} user
 * @returns {string}
 * @deprecated
 */
export function getAdalLastName(user) {
    // If impersonating the profile has a UserProfile, family_name = surname
    return user && user.profile ? user.profile.family_name || user.profile.surname : undefined;
}
/**
 * Gets the email address of the usr
 *
 * @export
 * @param {(adal.User | UserProfile)} user
 * @returns {string}
 */
export function getEmailAddress(user) {
    if (user && user.profile) {
        return getEmailValue(user.profile);
    }
    return getEmailValue(user);
}
//# sourceMappingURL=user-profile-helpers.js.map